<template>
  <div>
    <div class="admin__header">
      <div class="admin-survey-pages">
        <steps :items="pages" :active-item="activePage" :click-event="goToPage" v-if="pages.length > 1"></steps>
        <h2 v-if="pages && pages.length === 1">{{ pages[0].title }}</h2>
      </div>
    </div>

    <page-show></page-show>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex';
  import NoItems from '@/components/admin/NoItems';
  import Steps from '@/components/Steps';
  import PageShow from '@/components/admin/pages/Show';

  export default {
    name: 'admin-pages',

    components: {
      'no-items': NoItems,
      'page-show': PageShow,
      steps: Steps,
    },

    computed: {
      ...mapState({
        pages: state => state.admin.page.pages,
      }),

      ...mapGetters('admin', [
        'activeSurvey',
        'activePage',
      ]),

      ...mapGetters('admin', {
        fields: 'activeFields',
      }),
    },

    methods: {
      ...mapMutations('admin', [
        'setActivePage',
      ]),

      goToPage(page) {
        this.setActivePage(page.id);
      },
    },

    created() {
      this.setActivePage(1);
    },
  };
</script>
